import { TypographyColor } from 'melp-design/components';
import { SHOP_ITEM_TYPE_LABELS, ShopItemType } from 'store/shop';
import {
  ContentReviewEntityType,
  ContentReviewStatus,
  contentReviewEntityTypeLabels,
} from './admin-content-reviews.types';

export const COLOR_BY_CONTENT_REVIEW_STATUS: Record<
  ContentReviewStatus,
  TypographyColor
> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
};

export const contentReviewTypeLabel = (review: {
  entityType: ContentReviewEntityType;
  itemType?: ShopItemType | null;
}) => {
  if (review.entityType === 'service' && review.itemType) {
    return {
      key: `marketplaceItems.itemType.${review.itemType}`,
      defaultValue: SHOP_ITEM_TYPE_LABELS[review.itemType],
    };
  }

  return {
    key: `contentReviews.entityType.${review.entityType}`,
    defaultValue: contentReviewEntityTypeLabels[review.entityType],
  };
};
